delete window.BACKEND_BASE_URL;
delete window.CORS_URL;

const config = {
  BASE_URL:process.env.REACT_APP_BASE_URL,
  ACTUAL_URL:process.env.REACT_APP_BASE_URL,
  STATUS_URL:process.env.REACT_APP_STATUS_URL,
  API_KEY:process.env.REACT_APP_API_KEY,
  SUPERSET_DOMAIN:process.env.REACT_APP_SUPERSET_DOMAIN,
  SUPERSET_DASHBOARD_ID_LIGHT:process.env.REACT_APP_SUPERSET_DASHBOARD_ID_LIGHT,
  SUPERSET_DASHBOARD_ID_DARK:process.env.REACT_APP_SUPERSET_DASHBOARD_ID_DARK,
  SUPERSET_DASHBOARD_INTERNAL_ID_LIGHT:process.env.REACT_APP_SUPERSET_DASHBOARD_INTERNAL_ID_LIGHT,
  SUPERSET_DASHBOARD_INTERNAL_ID_DARK:process.env.REACT_APP_SUPERSET_DASHBOARD_INTERNAL_ID_DARK,
  SUPERSET_DASHBOARD_NATIVE_FILTER_TIME_RANGE_ID:process.env.REACT_APP_SUPERSET_DASHBOARD_NATIVE_FILTER_TIME_RANGE_ID,
  SUPERSET_DASHBOARD_NATIVE_FILTER_PROVIDER_ID:process.env.REACT_APP_SUPERSET_DASHBOARD_NATIVE_FILTER_PROVIDER_ID,
  SUPERSET_DASHBOARD_NATIVE_FILTER_INTEGRATION_ID:process.env.REACT_APP_SUPERSET_DASHBOARD_NATIVE_FILTER_INTEGRATION_ID,
  SUPERSET_DASHBOARD_NATIVE_FILTER_MARKET_ID:process.env.REACT_APP_SUPERSET_DASHBOARD_NATIVE_FILTER_MARKET_ID,
  SUPERSET_DASHBOARD_INTERNAL_NATIVE_FILTER_TIME_RANGE_ID:process.env.REACT_APP_SUPERSET_DASHBOARD_INTERNAL_NATIVE_FILTER_TIME_RANGE_ID,
  SUPERSET_DASHBOARD_INTERNAL_NATIVE_FILTER_PROVIDER_ID:process.env.REACT_APP_SUPERSET_DASHBOARD_INTERNAL_NATIVE_FILTER_PROVIDER_ID,
  SUPERSET_DASHBOARD_INTERNAL_NATIVE_FILTER_INTEGRATION_ID:process.env.REACT_APP_SUPERSET_DASHBOARD_INTERNAL_NATIVE_FILTER_INTEGRATION_ID,
  SUPERSET_DASHBOARD_INTERNAL_NATIVE_FILTER_MARKET_ID:process.env.REACT_APP_SUPERSET_DASHBOARD_INTERNAL_NATIVE_FILTER_MARKET_ID
};

export default config;
